(() => {
  const recipes = window.NanaTastingLibrary?.recipes;
  if (!recipes) return;
  const overviews = {
    109: ['Ground beef', 'Sour cabbage leaves', 'Long-grain rice', 'Olive oil, tomato juice and herbs'],
    204: ['Ground beef', 'Potatoes, onion and garlic', 'Plain beef stock', 'Butter pastry'],
    220: ['Beef', 'Egusi melon seeds', 'Leafy greens', 'Plain beef stock'],
    277: ['Flank steak', 'Plain pinto beans and rice', 'Plantains', 'Eggs, avocado and tomato'],
    289: ['Soft tofu', 'Ground beef', 'Beef tallow', 'Plain doubanjiang and fermented black beans'],
    308: ['Chicken', 'Coconut milk', 'Rice noodles', 'Shellfish-free spice paste'],
    356: [],
    336: ['Beef chuck', 'Onions', 'Beef tallow', 'Tomato paste and sweet paprika'],
    363: ['Cod or sea bass', 'Tomatoes', 'Extra-virgin olive oil', 'Garlic and parsley']
  };
  for (const [day, ingredients] of Object.entries(overviews)) {
    if (recipes[day]) recipes[day].ingredientOverview = ingredients;
  }
})();
